/**
 * @groundcover/browser persists the RUM session id in sessionStorage under this key
 * (see SDK bundle: getSessionId reads `gcId` when no in-memory sessionId).
 *
 * This is not added to the browser URL (e.g. `/api/user` has no `?gcid=`). The SPA sends the same
 * value on API calls as the request header `X-RUM-Session-Id` (see `ApiService` prepareHeaders).
 * Docs: docs/observability/correlation-rum-azure-front-door.md
 */
export const GROUNDCOVER_BROWSER_SESSION_STORAGE_KEY = 'gcId';

/** Must match `RUM_SESSION_HEADER` in `api/src/constants/correlationHeaders.ts` (RUM id, not app auth session). */
export const RUM_SESSION_HEADER = 'X-RUM-Session-Id';

/**
 * Returns the current Groundcover RUM session id when the SDK has initialized, or undefined.
 */
export function readGroundcoverRumSessionId(): string | undefined {
    try {
        if (typeof sessionStorage === 'undefined') return undefined;
        const v = sessionStorage.getItem(GROUNDCOVER_BROWSER_SESSION_STORAGE_KEY);
        if (!v) return undefined;
        const t = v.trim();
        return t.length > 0 ? t : undefined;
    }
    catch {
        return undefined;
    }
}

/** Use with `fetch(..., { headers })` so non-RTK calls still send the same RUM correlation header as `ApiService` `prepareHeaders`. */
export function withGroundcoverRumSessionHeaders(base?: HeadersInit): Headers {
    const merged = new Headers(base ?? undefined);
    const rumSessionId = readGroundcoverRumSessionId();
    if (rumSessionId) {
        merged.set(RUM_SESSION_HEADER, rumSessionId);
    }
    return merged;
}
